<template>
  <section class="n-view-register h-screen p-10 flex justify-center items-center">
    <NCard class="w-full max-w-[450px] shadow-md">
      <div class="text-center">
        <img class="mx-auto p-8" src="/images/logo-dark.png" alt="" />
        
        <div class="p-4"><span class="text-red-600 font-bold">{{ $tl('guestForbidden') }}</span></div>
      </div>
      <div class="mt-10 mb-3 text-center text-base text-gray-600 grid items-center gap-3 grid-flow-col place-content-center">
        {{ COPYRIGHT }}
        <NChannelSwitch />
        <NLanguageSwitcher />
        <NHelper />
      </div>
    </NCard>
  </section>
</template>

<script setup>
import {COPYRIGHT} from '@front/constant';
import {useLanguage, useRouter} from '@front/hooks';

const { tl, t, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();

</script>

<style lang="less">
.n-view-register {
  background-image: url('/images/shape01.png');
  background-position: center;

  .n-language-switcher {
    gap: 6px;
  }
}
</style>
